import useSWR, { SWRResponse } from "swr";
import { Contract } from "../../types";
// @ts-ignore
import useHttpClient from "../useHttpClient";
import { AxiosInstance } from "axios";


const useContract = (uuid: string, enabled = true): SWRResponse<Contract, Error> => {
  const httpClient: AxiosInstance = useHttpClient();
  const key = enabled && uuid ? `contract-${uuid}` : null;

  return useSWR(
    key,
    enabled && uuid
      ? async (): Promise<Contract> => {
        const response = await httpClient.get(`/contracts/${uuid}`);
        return response.data.data;
      }
      : null,
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
    }
  );
};

export default useContract;

